import React, { PropsWithChildren } from 'react';

export interface CaseProps {
  when: any;
}

export const Case: React.FunctionComponent<PropsWithChildren<CaseProps>> = (
  props: PropsWithChildren<CaseProps>
) => {
  return <>{props.children}</>;
};
